module.exports = __webpack_public_path__ + "195c4e60f17a6c0ab5de185f572a5d57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/goutte-moins.svg
// module id = 755
// module chunks = 0